<template>
  <div>
    <div id="delete-confirmation-modal" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <xCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
          <div class="text-3xl mt-5">Are you sure?</div>
          <div class="text-gray-600 mt-2">
            Do you really want to delete these row? This process cannot be
            undone.
          </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 border text-gray-700 mr-1"
          >
            Cancel
          </button>
          <button type="button"
                  class="button w-24 bg-theme-6 text-white"
                  data-dismiss="modal"
                  @click="deleteBionet"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
    <a
        href="javascript:;"
        data-toggle="modal"
        id="modal-success"
        style="display: none"
        data-target="#success-modal-preview"
        class="button inline-block bg-theme-1 text-white"
    ></a>
    <div id="success-modal-preview" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <CheckCircleIcon
              class="w-16 h-16 text-theme-9 mx-auto mt-3"
          />
          <div class="text-gray-600 mt-2">
            {{modalText}}
          </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-1 text-white"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
    <a
        href="javascript:;"
        data-toggle="modal"
        data-target="#warning-modal-preview"
        style="display: none"
        id="show-modal"
        class="button inline-block bg-theme-1 text-white"
    >Show Modal</a
    >
    <div id="warning-modal-preview" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <xCircleIcon class="w-16 h-16 text-theme-12 mx-auto mt-3" />
          <div class="text-3xl mt-5">Oops...</div>
          <div class="text-gray-600 mt-2">{{modalText}}</div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-1 text-white"
          >
            Ok
          </button>
        </div>
        <div
            class="p-5 text-center border-t border-gray-200 dark:border-dark-5"
        >
        </div>
      </div>
    </div>
    <h2 class="intro-y text-lg font-medium mt-10">Bionet tool</h2>
    <div class="col-span-12 mt-8">
      <div class="intro-y flex items-center h-10">
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-6 box">
        <!-- BEGIN: File Type Validation -->
        <div class="intro-y box">
          <div
              class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200 dark:border-dark-5"
          >
            <h2 class="font-medium text-base mr-auto">Upload Logo</h2>
          </div>

          <div id="file-type-validation" class="p-5">
            <div class="preview">
              <VueDropzone
                  id="dropzone-validation"
                  ref="MyDropzone"
                  :use-custom-slot="true"
                  :options="{
                  url: 'https://httpbin.org/post',
                  maxFiles: 1,
                  addRemoveLinks: true
                }"
                  class="dropzone font-roboto border-gray-200 border-dashed text-gray-800 hover:bg-transparent"
                  @vdropzone-file-added="validateFileEvent"
                  @vdropzone-error="dropzoneError"
                  @vdropzone-removed-file="removeEvent"
              >
                <div class="text-lg font-medium">
                  Drop files here or click to upload.
                </div>
                <div class="text-gray-600"></div>
              </VueDropzone>
            </div>
          </div>
          <div class="text-center">
            <button
                type="button"
                class="button inline-block bg-theme-1 text-white"
                :disabled="file === null"
                @click="createFile"
            >
              Upload
            </button>
          </div>
        </div>
        <!-- END: File Type Validation -->
      </div>
      <div class="intro-y col-span-12 lg:col-span-6 box">
        <div class="intro-y box lg:mt-5">
          <div
              class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5"
          >
            <h2 class="font-medium text-base mr-auto">Start parsing</h2>
          </div>
          <div class="p-5">
            <div class="grid grid-cols-12 gap-5">
              <div class="col-span-12 xl:col-span-6">
                <div class="mt-3">
                  <label>Latitude</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="lat"
                      v-model="bionet.lat"
                  />
                </div>
              </div>
              <div class="col-span-12 xl:col-span-6">
                <div class="mt-3">
                  <label>Longitude</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="lon"
                      v-model="bionet.lon"
                  />
                </div>
              </div>
              <div class="col-span-12 xl:col-span-6">
                <div class="mt-3">
                  <label>Start year</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="start year"
                      v-model="bionet.startYear"
                  />
                </div>
              </div>
              <div class="col-span-12 xl:col-span-6">
                <div class="mt-3">
                  <label>End year</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="end year"
                      v-model="bionet.endYear"
                  />
                </div>
              </div>
              <div class="col-span-12 xl:col-span-6">
                <div>
                  <label>Radius (km)</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="radius"
                      v-model="bionet.radius"
                  />
                </div>
              </div>
              <div class="col-span-12 xl:col-span-6">
                <div>
                  <label>Email for notification</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="mail"
                      v-model="bionet.email"
                  />
                </div>
              </div>
              <div class="col-span-12 xl:col-span-6">
                <div>
                  <label>Map title</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="max 30 chars"
                      v-model="bionet.maptitle"
                  />
                </div>
              </div>
              <div class="col-span-12 xl:col-span-6">
                <div>
                  <label>Map text</label>
                  <textarea
                      v-model="bionet.maptext"
                      class="input w-full border mt-2"
                      placeholder="max 150 chars"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="flex justify-end mt-4">
              <button
                  type="button"
                  class="button w-20 bg-theme-1 text-white ml-auto"
                  @click="submitBionet"
              >
                Run
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
<br>
<br>
    <div class="intro-y col-span-12 lg:col-span-6 box">
      <div class="intro-y box">
        <div
            class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">Recent activity</h2>
          <div
              class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2"
          >
          </div>
        </div>

        <div id="basic-table-keywords" class="p-5">
          <div class="preview">
            <div class="overflow-x-auto">
              <table class="table">
                <thead>
                <tr>
                  <th class="text-center whitespace-no-wrap">lat</th>
                  <th class="text-center whitespace-no-wrap">lon</th>
                  <th class="text-center whitespace-no-wrap">start year</th>
                  <th class="text-center whitespace-no-wrap">end year</th>
                  <th class="text-center whitespace-no-wrap">radius</th>
                  <th class="text-center whitespace-no-wrap">status</th>
                  <th class="text-center whitespace-no-wrap">Action</th>
                  <th class="text-center whitespace-no-wrap"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(res, resKey) in displayedResults" :key="resKey" class="intro-x">
                  <td class="text-center">
                    {{ res.lat }}
                  </td>
                  <td class="text-center">{{ res.lon }}</td>
                  <td class="text-center">{{ res.startYear }}</td>
                  <td class="text-center">{{ res.endYear }}</td>
                  <td class="text-center">{{ res.radius }}</td>
                  <td v-if="res.status === 0" class="text-center">Pending</td>
                  <td v-if="res.status === 1" class="text-center">Success</td>
                  <td v-if="res.status === 2" class="text-center">Error</td>
                  <td class="table-report__action w-56">
                    <div class="flex justify-center items-center">
                      <a v-if="res.status === 1" class="flex items-center mr-3"
                         :href="apiUrl + 'bionet/upload/' + res.fname + '.zip'"
                      >
                        <CheckSquareIcon class="w-4 h-4 mr-1" />
                        Upload
                      </a>
                    </div>
                  </td>
                  <td class="table-report__action w-56">
                    <div class="flex justify-center items-center">
                      <a
                          class="flex text-theme-6"
                          href="javascript:;"
                          data-toggle="modal"
                          data-target="#delete-confirmation-modal"
                          @click="deleteItem(res)"
                      >
                        <Trash2Icon class="w-4 h-4 mr-1" /> Delete
                      </a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div
          class="intro-y flex flex-wrap sm:flex-row sm:flex-no-wrap items-center mt-3"
          v-if="resultPages.length > 0"
      >
        <ul class="pagination">
          <li>
            <a class="pagination__link" @click="resultPage > 4 ? resultPage = resultPage - 4 : resultPage">
              <ChevronsLeftIcon class="w-4 h-4" />
            </a>
          </li>
          <li>
            <a class="pagination__link" @click="resultPage!==1 ? resultPage = resultPage - 1 : resultPage = 1">
              <ChevronLeftIcon class="w-4 h-4" />
            </a>
          </li>
          <li v-if="resultPage > 4" @click="resultPage = 1">
            <a class="pagination__link">1</a>
          </li>
          <li v-if="resultPage > 4">
            <a class="pagination__link">...</a>
          </li>
          <li v-for="(pageNumber, key) in resultPages.slice(resultPage-1, resultPage+3)" @click="resultPage = pageNumber" v-bind:key="key">
            <a style="background-color: #A9A9A9;" v-if="pageNumber === resultPage" class="pagination__link pagination__link--active">{{pageNumber}}</a>
            <a v-else class="pagination__link">{{pageNumber}}</a>
          </li>
          <li>
            <a class="pagination__link">...</a>
          </li>
          <li v-if="resultPage !== resultPages.length && resultPages.length > 4">
            <a class="pagination__link" @click="resultPage = resultPages.length">{{ resultPages.length }}</a>
          </li>
          <li>
            <a class="pagination__link" @click="resultPage!==resultPages.length ? resultPage = resultPage + 1 : resultPage = resultPages.length">
              <ChevronRightIcon class="w-4 h-4" />
            </a>
          </li>
          <li>
            <a class="pagination__link" @click="resultPage <= resultPages.length - 4 ? resultPage = resultPage + 4 : resultPage">
              <ChevronsRightIcon class="w-4 h-4" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import AuthService from "@/services/Auth";
import vue2Dropzone from "vue2-dropzone";
const authService = new AuthService();
// import Tabulator from "tabulator-tables";

export default {
  components: {
    VueDropzone: vue2Dropzone
  },
  data() {
    return {
      file: null,
      modalText: "",
      infoError: false,
      apiUrl: "https://www.pmstconverter.com/api/",
      bionet: {
        endYear: 2012,
        startYear: 1980,
        radius: 2,
        lat: undefined,
        lon: undefined,
        email: undefined,
        logo: undefined,
        maptext: undefined,
        maptitle: undefined
      },
      bionetDefault: {
        endYear: 2012,
        startYear: 1980,
        radius: 2,
        lat: undefined,
        lon: undefined,
        email: undefined,
        logo: undefined,
        maptext: undefined,
        maptitle: undefined
      },
      results: null,
      resultPage: 1,
      resultPerPage: 5,
      resultPages: [],
      ordersCount: null,
      settings: null,
      editedIndex: -1,
      editedIndexSettings: -1,
      itemToDelete: {
        id: undefined,
        endYear: 2012,
        startYear: 1980,
        radius: 2,
        lat: undefined,
        lon: undefined,
        email: undefined,
        logo: undefined,
        maptext: undefined,
        maptitle: undefined
      },
      defaultItem: {
        id: undefined,
        endYear: 2012,
        startYear: 1980,
        radius: 2,
        lat: undefined,
        lon: undefined,
        email: undefined,
        logo: undefined,
        maptext: undefined,
        maptitle: undefined,
      },
      dialog: false,
      filter: {
        field: "name",
        type: "like",
        value: ""
      }
    };
  },
  computed: {
    displayedResults () {
      let self = this
      return self.paginate(self.results, self.resultPage, self.resultPerPage);
    },
  },
  watch: {
    results () {
      this.setPages(this.results, this.resultPerPage);
    }
  },
  created(){
    this.getBionetResults();
    this.bionet.email = authService.getUser().email
  },
  methods: {
    deleteItem(item) {
      this.itemToDelete = item
    },
    deleteBionet() {
      const index = this.results.indexOf(this.itemToDelete)
      axios.delete('bionet/delete/' + this.itemToDelete.id)
          .then(() => {
            this.results.splice(index, 1)
            this.itemToDelete = this.defaultItem
          })
    },
    validateFileEvent(file) {
      this.file = file;
    },
    createFile() {
      axios
          .put("bionet/logo/", this.file, {
            headers: {
              "Content-Disposition":
                  "attachment; filename=" + this.file.upload.filename,
            }
          })
          .then(response => {
            if (response.data.status && response.data.status === "success") {
              // console.log(response.data);
              this.modalText = "File success uploaded"
              document.getElementById("modal-success").click()

            } else {
              this.modalText = "Err. File not uploaded"
              document.getElementById("show-modal").click()
              this.$refs.MyDropzone.removeFile(this.file);
            }
          })
          .catch(err => {
            // console.log(err);
            this.error = err;
          });
    },
    // Filter function
    dropzoneError(err) {
      // console.log(err);
      if (!err.type.includes("image")) {
        alert("Error! Files of this type are not accepted");
      }
    },
    // eslint-disable-next-line no-unused-vars
    removeEvent(file) {
      // console.log(file);
      this.file = null;
    },
    onFilter() {
      this.table.setFilter(
        this.filter.field,
        this.filter.type,
        this.filter.value
      );
    },
    setPages (items, perPage) {
      let numberOfPages = Math.ceil(items.length / perPage);
      this.resultPages = [];
      for (let index = 1; index <= numberOfPages; index++) {
        this.resultPages.push(index);
      }
    },
    paginate (posts, accountPage, accountPerPage) {
      try {
        let page = accountPage;
        let perPage = accountPerPage;
        let from = (page * perPage) - perPage;
        let to = (page * perPage);
        console.log(posts)
        console.log("posts")
        return  posts.slice(from, to);
      } catch (error) {
        console.error(error);
        // expected output: ReferenceError: nonExistentFunction is not defined
        // Note - error messages will vary depending on browser
      }
    },
    submitBionet() {
      this.bionet.logo = this.file.upload.filename
      axios.post('bionet/add', this.bionet)
          .then(response => {
            console.log(response.data)
            this.bionet = this.bionetDefault
            this.infoError = true
            this.results.push(response.data.bionet)
            this.$refs.MyDropzone.removeFile(this.file);
          });
    },
    getBionetResults() {
      axios
        .get("bionet/results")
        .then(response => {
          let data = response.data;
          this.results = data;
        })
        .catch(function(error) {
          console.error(error.response);
        });
    },

    // On reset filter
    onResetFilter() {
      this.filter.field = "name";
      this.filter.type = "like";
      this.filter.value = "";
      this.onFilter();
    },
  },
};
</script>
